import { render } from "./CommonNotFound.vue?vue&type=template&id=029f3208&scoped=true"
import script from "./CommonNotFound.vue?vue&type=script&lang=js"
export * from "./CommonNotFound.vue?vue&type=script&lang=js"

import "./CommonNotFound.vue?vue&type=style&index=0&id=029f3208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029f3208"]])

export default __exports__